import 'dayjs/locale/pl';
import { AppRouter } from 'pages';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <>
      <Helmet titleTemplate="%s | Connectis Hub" />
      <AppRouter />
    </>
  );
}

export default App;
